
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[uid]",
      function () {
        return require("private-next-pages/[uid].tsx");
      }
    ]);
  